type Result = {
	topics: Array<
		Readonly<{
			name: string;
			slug: string;
		}>
	>;
};

const curatedTopics = [
	{ name: 'Human Rights', slug: 'human-rights-11' },
	{ name: 'Education', slug: 'education-en-us' },
	{ name: 'Government and Politics', slug: 'government-and-politics-en-us' },
	{ name: 'Entertainment', slug: 'entertainment-11' },
	{ name: 'Criminal Justice', slug: 'criminal-justice-en-US' },
	{ name: 'Health and Well-Being', slug: 'health-and-well-being-en-us' },
	{ name: 'Child and Family Well-Being', slug: 'child-and-family-well-being-en-us' },
	{ name: 'Economic Justice', slug: 'economic-justice-10' },
	{ name: 'Health', slug: 'health-en-us' },
	{ name: 'Public Safety', slug: 'public-safety-2' },
	{ name: 'Politics', slug: 'politics-9' },
	{ name: 'Animals', slug: 'animals-13' },
	{ name: 'Business and Economy', slug: 'business-and-economy-en-us' },
	{ name: 'Environment', slug: 'environment-12' },
	{ name: 'Racial Justice', slug: 'racial-justice-4' },
	{ name: 'Entertainment & Media', slug: 'entertainment-media-en-us' },
	{ name: "Women's Rights", slug: 'women-s-rights-en-us' },
	{ name: 'Technology', slug: 'technology-9' },
	{ name: 'Environmental Issues', slug: 'environmental-issues-en-us' },
	{ name: 'Sports', slug: 'sports-12' },
	{ name: 'Food', slug: 'food-9' },
	{ name: 'Animal Rights and Conservation', slug: 'animal-rights-and-conservation-en-us' },
	{ name: 'Ethnic and Racial Minorities', slug: 'ethnic-and-racial-minorities-en-us' },
	{ name: 'Family', slug: 'family-2' },
	{ name: 'Health and Safety', slug: 'health-and-safety' },
	{ name: 'Disability', slug: 'disability-en-us' },
	{ name: 'LGBTQ', slug: 'lgbtq-en-us' },
];

export const useCuratedTopicsSection = (): Result => {
	return {
		topics: curatedTopics,
	};
};
